import { render, staticRenderFns } from "./CompanyViewInfoCard.vue?vue&type=template&id=85eebcfa&v-if=companyData&"
import script from "./CompanyViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./CompanyViewInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports